export default "__VITE_ASSET__BykR2efj__"